/* eslint-disable global-require */
import type { LoadingColor, LoadingType } from '..';

export const loadingIcon: Record<LoadingColor, Record<LoadingType, string>> = {
  light: {
    audio: require('./light/audio.svg'),
    'ball-triangle': require('./light/ball-triangle.svg'),
    ballbounce: require('./light/ballbounce.svg'),
    bars: require('./light/bars.svg'),
    circles: require('./light/circles.svg'),
    grid: require('./light/grid.svg'),
    hearts: require('./light/hearts.svg'),
    oval: require('./light/oval.svg'),
    pacman: require('./light/pacman.svg'),
    puff: require('./light/puff.svg'),
    rings: require('./light/rings.svg'),
    'spinning-circles': require('./light/spinning-circles.svg'),
    'tail-spin': require('./light/tail-spin.svg'),
    'three-dots': require('./light/three-dots.svg'),
    threedots: require('./light/threedots.svg'),
  },
  dark: {
    audio: require('./dark/audio.svg'),
    'ball-triangle': require('./dark/ball-triangle.svg'),
    ballbounce: require('./dark/ballbounce.svg'),
    bars: require('./dark/bars.svg'),
    circles: require('./dark/circles.svg'),
    grid: require('./dark/grid.svg'),
    hearts: require('./dark/hearts.svg'),
    oval: require('./dark/oval.svg'),
    pacman: require('./dark/pacman.svg'),
    puff: require('./dark/puff.svg'),
    rings: require('./dark/rings.svg'),
    'spinning-circles': require('./dark/spinning-circles.svg'),
    'tail-spin': require('./dark/tail-spin.svg'),
    'three-dots': require('./dark/three-dots.svg'),
    threedots: require('./dark/threedots.svg'),
  },
};
